import { render } from "./UpdateClinicalCase.vue?vue&type=template&id=147df826&scoped=true"
import script from "./UpdateClinicalCase.vue?vue&type=script&lang=js"
export * from "./UpdateClinicalCase.vue?vue&type=script&lang=js"

import "./UpdateClinicalCase.vue?vue&type=style&index=0&id=147df826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-147df826"]])

export default __exports__